import { Component, inject } from '@angular/core';
import Map from '@arcgis/core/Map';
import { JmkwApiService, JmkwModule } from '@jeppesen-foreflight/jmkw-core';
import {
  AviationPluginService,
  JmkwPluginModule,
  JmkwPluginService,
  TerrainPluginService
} from '@jeppesen-foreflight/jmkw-extensions';
import {
  EsriViewType,
  LayerResults,
  PluginConfigurationRecord,
  PluginMap,
  ViewConfig
} from '@jeppesen-foreflight/jmkw-types';
import { Observable, combineLatest, map } from 'rxjs';
import { HeaderToolsComponent } from '../../layout/header-tools/header-tools.component';
import { ResizableLayoutComponent } from '../../layout/layout.component';
import { AIR_TEMPERATURE_PLUGIN } from '../../plugins/air-temperature/air-temperature.plugin';
import { MOCK_SEARCH_PLUGIN } from '../../plugins/mock-search/mock-search.plugin';
import { UNIT_CONFIG_PLUGIN } from '../../plugins/unit-config/unit-config.plugin';
import { ZoomLevelPlugin } from '../../plugins/zoom-level/zoom-level.plugin';

export const DEFAULT_CONFIG: PluginConfigurationRecord = {
  'view-toggle': { button: { order: 1 } },
  location: { button: { order: 2 } },
  theme: { button: { order: 3 } },
  terrain: { button: { order: 4 } },
  obstacles: { button: { order: 5 } },
  cultural: { button: { order: 6 } },
  navigation: {
    layer: {
      ifr: 'Low',
      visible: true,
      zOrder: 9000,
      layers: {
        airway: { visible: true },
        airport: { visible: true },
        airspace: {
          visible: true,
          layers: {
            fir: { visible: true },
            atc: { visible: true },
            operational: { visible: true },
            special: { visible: true },
            terminal: { visible: true }
          }
        },
        amdb: { visible: true },
        navaid: { visible: true },
        waypoint: { visible: true },
        latlon: { visible: true },
        grid_mora: { visible: true }
      }
    }, // navigation is the parent and owner of its pseudolayers. The zOrder set here will dictate all the subsets of vectorStyleLayer groups (aka pseudolayers)
    button: {
      // iconName: 'icon-face',
      order: 7
    }
  },
  'ifr-toggle': { button: { order: 8 } },
  personas: { button: { order: 9 } },
  twc_weather: { button: { order: 10 } },
  'air-temperature': { button: { order: 11 } },
  'unit-config': { button: { order: 12 } },
  'mock-search': { button: { order: 0 } },
  zoom_level: { layer: { visible: true } }
};
@Component({
  selector: 'test-core-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  standalone: true,
  imports: [
    HeaderToolsComponent,
    ResizableLayoutComponent,
    JmkwModule,
    JmkwPluginModule
  ]
})
export class MapComponent {
  private readonly jmkwService = inject(JmkwApiService);
  private readonly jmkwPluginService = inject(JmkwPluginService); // Inject the new module

  ZOOM_LEVEL_PLUGIN = new ZoomLevelPlugin();
  // Expose aviation plugin service and terrain plugin for test injection/mocking

  userDefinedPluginMap$: Observable<PluginMap> = combineLatest([
    this.jmkwPluginService.pluginMap$() // Use the method from the module
  ]).pipe(
    map(([plugins]: [PluginMap]) => {
      // Add a sample WebTileLayer plugin

      plugins.set(AIR_TEMPERATURE_PLUGIN.id, AIR_TEMPERATURE_PLUGIN);
      plugins.set(UNIT_CONFIG_PLUGIN.id, UNIT_CONFIG_PLUGIN);
      plugins.set(this.ZOOM_LEVEL_PLUGIN.id, this.ZOOM_LEVEL_PLUGIN);
      plugins.set(MOCK_SEARCH_PLUGIN.id, MOCK_SEARCH_PLUGIN);

      return plugins;
      // .filter(
      //   (plugin) => plugin.id !== 'twc_weather'
      // ) as PluginMap;
    })
  );

  pluginConfigurationMap: PluginConfigurationRecord = DEFAULT_CONFIG;

  onViewsLoaded(esriViews: Record<EsriViewType, ViewConfig>) {
    console.log('onViewsLoaded', esriViews);
  }

  onMapLoaded(esriMap: Map) {
    console.log('onMapLoaded', esriMap);
  }

  onPluginsUpdated(plugins: PluginMap) {
    console.log(`onPluginsUpdated:`, plugins);
  }

  onLayersLoaded(results: LayerResults) {
    console.log('onLayersLoaded', results);
    this.ZOOM_LEVEL_PLUGIN.addZoomComponent();
  }

  onInitialized(results: PluginMap) {
    console.log('onInitialized', results);
  }
}
